// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ihn3","notes":"Notes_notes__kg8sh"};